/* eslint-disable react/prop-types */
import { useState } from "react";

import { colors, strCode } from "../../../../../consts";

import {
  Checkbox,
  DeviceInfo,
  FlexContainers,
  GradientLoader,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../../components";
import { dateUtil, deviceUtil } from "../../../../../utils";
import { CellWrapper } from "../../../../../components/Table/styled";

const exactMatchFilter = (rows, id, filterValue) => {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue === filterValue || !filterValue;
  });
};

export const DownloadRevokeTableColumns = [
  {
    id: "selecting",
    Header: ({ rows, callbackFn1: getSelected, callbackFn2: onAllCheck, isLoading }) => {
      const { isAllSelected, selectedLength } = getSelected();

      return rows?.length > 0 ? (
        <Checkbox
          onCheck={() => onAllCheck(rows)}
          checked={isAllSelected}
          partiallyChecked={selectedLength}
          disabled={isLoading}
        />
      ) : null;
    },
    Cell: ({ cell, callbackFn3: checkIsRowSelected, callbackFn4: onRowCheck, isLoading }) => {
      const isSelected = checkIsRowSelected(cell.row.original.id);

      return (
        <Checkbox
          onCheck={(e) => {
            e.stopPropagation();
            onRowCheck(cell.row.original.id);
          }}
          checked={isSelected}
          disabled={isLoading}
        />
      );
    }
  },
  {
    Header: strCode.DEVICE_TITLE,
    accessor: "deviceName",
    filter: exactMatchFilter,
    Cell: ({ cell, cellWidth5, isLoading }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);
      const [deviceImage, setDeviceImage] = useState();

      const record = cell?.row?.original;
      const isMercuryDevice = record?.isMercuryDevice;

      deviceUtil.getDeviceImageAsset(record?.deviceImage, isMercuryDevice).then((res) => {
        setDeviceImage(res);
      });

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <DeviceInfo
            isLoading={isLoading}
            isImageLoaded={isImageLoaded}
            imageSrc={deviceImage}
            setIsImageLoaded={setIsImageLoaded}
            model={cell.value}
            type={record.type}
            width={cellWidth5}
          />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.SERIAL_NUMBER_TITLE,
    accessor: "dusn",
    Cell: ({ cell, isLoading, searchedText }) => {
      return (
        <CellWrapper width="260px">
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }} highlightedText={searchedText}>
            {isLoading ? (
              <GradientLoader width={260} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CERTIFICATE_CREATED_BY_TITLE,
    id: "createdBy",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const record = cell?.row?.original;
      const { createdBy, createdTs } = record ?? {};

      const author = `${createdBy?.firstName} ${createdBy?.lastName}`;
      let timestamp = null;

      try {
        const date = dateUtil.getUTCDate(new Date(createdTs * 1000));
        timestamp = date?.getTime();
      } catch (e) {
        timestamp = null;
      }

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer Container={FlexContainers.FlexColumn} gap={4} alignItems="start">
            <TextOverflowWrapper>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={32} />
              ) : (
                author
              )}
            </TextOverflowWrapper>

            <TextOverflowWrapper style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={32} />
              ) : (
                dateUtil.formatDateFromTimestamp(timestamp)
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.EXPIRATION_DATE_TITLE,
    id: "expirationDate",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const record = cell?.row?.original;
      const { expirationDate } = record ?? {};

      let timestamp = null;

      try {
        const date = dateUtil.getUTCDate(new Date(expirationDate * 1000));
        timestamp = date?.getTime();
      } catch (e) {
        timestamp = null;
      }

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer Container={FlexContainers.FlexColumn} gap={4} alignItems="start">
            <TextOverflowWrapper style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={32} />
              ) : (
                dateUtil.formatDateFromTimestamp(timestamp)
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
